import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'
import borderSvg from 'resources/svg/ppl-border-texture.svg'

export const Wrapper = styled.div`
  padding: 0 15px;
  max-width: 950px;
  margin: 0 auto;

  h2 {
    ${props => props.theme.css.heading1};
    font-weight: ${props => props.theme.font.alt.bold};
    margin-bottom: 6vw;
    text-align: center;
  }

  .actions {
    margin-top: 8vw;
  }
`

export const Row = styled.div<{ alignContentToRight: boolean }>`
  display: flex;
  align-items: center;
  padding: 20px 6vw;
  position: relative;
  z-index: 1;
  ${props => props.alignContentToRight && `
    flex-direction: row-reverse;
    justify-content: flex-start;
    text-align: right;
  `}

  &:nth-of-type(odd) {
    margin: 25px 0;
    background-color: ${props => props.theme.productSelector.landingPink};

    &::before,
    &::after {
      content: '';
      width: 100%;
      height: 100%;
      display: block;
      position: absolute;
      background: url(${borderSvg}) no-repeat center / cover;
      left: 0;
      z-index: -1;
      pointer-events: none;
    }

    &::before {
      top: -30%;
    }

    &::after {
      bottom: -28%;
    }
  }

  img {
    width: 140px;
    height: auto;
    ${bp('sm')`
      width: 70px;
    `}
  }

  p {
    font-size: 30px;
    margin: 0 30px;
    line-height: 1.3;
    ${bp('sm')`
      font-size: 18px;
      margin: 0 15px;
    `}
  }
`
